'use strict';

/**
 * Объект глобального скопа GSAP
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @type {Object}
 * @global
 * @prop {Object} Cubic
 * @prop {Object} Cubic.easeIn
 * @prop {Object} Cubic.easeInOut
 * @prop {Object} Cubic.easeOut
 * @prop {Object} Ease
 * @prop {Object} Linear
 * @prop {Object} Linear.easeIn
 * @prop {Object} Linear.easeInOut
 * @prop {Object} Linear.easeNone
 * @prop {Object} Linear.easeOut
 * @prop {Object} Power0
 * @prop {Object} Power0.easeIn
 * @prop {Object} Power0.easeInOut
 * @prop {Object} Power0.easeNone
 * @prop {Object} Power0.easeOut
 * @prop {Object} Power1
 * @prop {Object} Power1.easeIn
 * @prop {Object} Power1.easeInOut
 * @prop {Object} Power1.easeOut
 * @prop {Object} Power2
 * @prop {Object} Power2.easeIn
 * @prop {Object} Power2.easeInOut
 * @prop {Object} Power2.easeOut
 * @prop {Object} Power3
 * @prop {Object} Power3.easeIn
 * @prop {Object} Power3.easeInOut
 * @prop {Object} Power3.easeOut
 * @prop {Object} Power4
 * @prop {Object} Power4.easeIn
 * @prop {Object} Power4.easeInOut
 * @prop {Object} Power4.easeOut
 * @prop {Object} Quad
 * @prop {Object} Quad.easeIn
 * @prop {Object} Quad.easeInOut
 * @prop {Object} Quad.easeOut
 * @prop {Object} Quart
 * @prop {Object} Quart.easeIn
 * @prop {Object} Quart.easeInOut
 * @prop {Object} Quart.easeOut
 * @prop {Object} Quint
 * @prop {Object} Quint.easeIn
 * @prop {Object} Quint.easeInOut
 * @prop {Object} Quint.easeOut
 * @prop {Object} Strong
 * @prop {Object} Strong.easeIn
 * @prop {Object} Strong.easeInOut
 * @prop {Object} Strong.easeOut
 * @prop {Object} com
 */
const GSAP = (window.GSAP || (window.GSAP = window.GreenSockGlobals = (window.GreenSockGlobals || {})));

// ----------------------------------------
// Exports
// ----------------------------------------

export default GSAP;



// WEBPACK FOOTER //
// ./src/js/_vendors/gsap/gsap.js